var map = {
	"./are-solar-panels-worth-it-in-melbourne.md": 221,
	"./how-long-do-solar-batteries-last.md": 9828,
	"./how-long-do-solar-panels-last.md": 2792,
	"./how-many-solar-panels-do-i-need.md": 2569
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8520;